module.exports = __webpack_public_path__ + "images/c4aaa0060a871c1dac19eb6f20ff424f.jpg";